import "./index.css";
import { Card, Col, Row } from "reactstrap";
import { CardBody, CardHeader } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import BreadCrumbs from "../../../components/BreadCrumbs";
import { formatTime12hrs } from "../../../utility/Utility";

const RestaurantDetailsView = () => {
  const location = useLocation();

  const restaurant = location.state?.restaurant;

  return (
    <>
      <BreadCrumbs hasSubMenus={false} />
      <br />
      <div className="restaurant-details-view-whole-component">
        <Card className="restaurant-details-view-card">
          <CardHeader className="restaurant-details-view-card-header">
            <h4>Restaurant Details</h4>
          </CardHeader>
          <CardBody>
            <div className="text-center mb-4">
              <img
                src={restaurant?.imageUrl}
                alt="restaurant "
                className="restaurant-details-view-card-body-restaurant-image"
              />
            </div>
            <div className="restaurant-details-view-info">
              <Row className="mb-3">
                <Col lg="4" className="font-weight-bold">
                  Restaurant Name
                </Col>
                <Col lg="8">: {restaurant?.displayName}</Col>
              </Row>
              <Row className="mb-3">
                <Col lg="4" className="font-weight-bold">
                  Address
                </Col>
                <Col lg="8">: {restaurant?.address}</Col>
              </Row>
              <Row className="mb-3">
                <Col lg="4" className="font-weight-bold">
                  Opening Time
                </Col>
                <Col lg="8">: {formatTime12hrs(restaurant?.openingTime)}</Col>
              </Row>
              <Row className="mb-3">
                <Col lg="4" className="font-weight-bold">
                  Closing Time
                </Col>
                <Col lg="8">: {formatTime12hrs(restaurant?.closingTime)}</Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default RestaurantDetailsView;
